import { render, staticRenderFns } from "./Temperature.vue?vue&type=template&id=1564f2ae&"
import script from "./Temperature.vue?vue&type=script&lang=js&"
export * from "./Temperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports